import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAPI, ADMIN_TOKEN_KEY } from '../../services/adminApi';
import './Admin.css';

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (token) {
      navigate('/admin');
    }
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const res = await adminAPI.login(username, password);
      localStorage.setItem(ADMIN_TOKEN_KEY, res.data.access_token);
      localStorage.setItem('admin_username', res.data.admin.username);
      navigate('/admin');
    } catch (err) {
      const statusCode = (err as any)?.response?.status;
      if (statusCode === 401) {
        setError('Usuário ou senha inválidos.');
      } else if ((err as any)?.code === 'ERR_NETWORK' || statusCode === undefined) {
        setError('Servidor indisponível. Verifique se o backend está rodando.');
      } else {
        setError('Erro ao fazer login. Tente novamente.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-page">
      <div className="admin-topbar">
        <button className="admin-topbar-button" onClick={() => navigate('/')}>
          Landing Page
        </button>
      </div>
      <div className="admin-login-card">
        <div className="admin-login-header">
          <span className="admin-badge">Admin</span>
          <h1>Painel ContratoSeguro</h1>
          <p>Acesso restrito para administradores</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-form">
          <label className="admin-label" htmlFor="admin-username">Usuário</label>
          <input
            id="admin-username"
            className="admin-input"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
          />

          <label className="admin-label" htmlFor="admin-password">Senha</label>
          <input
            id="admin-password"
            className="admin-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />

          {error && <div className="admin-error">{error}</div>}

          <button className="admin-submit" type="submit" disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
